import { Card, Col } from "react-bootstrap";

import rate from "../../images/rate.png";
import { Link } from "react-router-dom";
import imgNotFound from "../../images/category-icon.png";
import { ToastContainer } from "react-toastify";
import ProductCardHook from "./../../hook/products/product-card-hook";

const ProductCard = ({ item, favProd }) => {
  const [, , handelFav, favImg] = ProductCardHook(item, favProd);

  return (
    <Col className="col-12 col-sm-6 col-md-4 col-lg-3">
      <Card
        className="my-2"
        style={{
          width: "100%",
          borderRadius: "8px",
          border: "none",
          backgroundColor: "#FFFFFF",
          boxShadow: "0 2px 2px 0 rgba(151,151,151,0.5)",
        }}
      >
        <Link to={`/products/${item._id}`} style={{ textDecoration: "none" }}>
          <Card.Img
            style={{ height: "228px", width: "100%" }}
            src={item.image}
          />
        </Link>
        <Card.Header className="bg-white border-0 mb-0 pb-0">
          <div className="d-flex justify-content-between flex-row-reverse">
            {favImg ? (
              <img
                src={favImg}
                alt=""
                onClick={handelFav}
                className="text-center"
                style={{
                  height: "24px",
                  width: "26px",
                  cursor: "pointer",
                }}
              />
            ) : (
              <img
                src={imgNotFound}
                alt=""
                onClick={handelFav}
                className="text-center"
                style={{
                  height: "24px",
                  width: "26px",
                  cursor: "pointer",
                }}
              />
            )}
            <div className="d-flex">
              <img className="" src={rate} alt="" height="16px" width="16px" />
              <div className="card-rate mx-2">{item.ratingsAverage || 0}</div>
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          <Card.Title>
            <p
              className="card-title fw-bold"
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {item.title}
            </p>
          </Card.Title>
          <Card.Title>
            <div className="d-flex">
              <div className="card-price fs-5">
                {item.priceAfterDiscount >= 1 ? (
                  <div>
                    <span
                      style={{ textDecorationLine: "line-through" }}
                      className="fs-6"
                    >
                      {item.price}
                    </span>{" "}
                    {item.priceAfterDiscount}
                  </div>
                ) : (
                  item.price
                )}
              </div>
              <div className="card-currency mx-1">جنيه</div>
            </div>
          </Card.Title>
        </Card.Body>
      </Card>
      <ToastContainer />
    </Col>
  );
};

export default ProductCard;
